import VideoRecorderModal from './VideoRecorderModal';

export default VideoRecorderModal;
